/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetNewbuildingsFromBuilderRequest,
  TGetNewbuildingsFromBuilderModel,
  IMappers,
  TGetNewbuildingsFromBuilderResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetNewbuildingsFromBuilderResponse } from '../../entities/get_newbuildings_from_builder/GetNewbuildingsFromBuilderResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetNewbuildingsFromBuilderModel(
  parameters: TGetNewbuildingsFromBuilderRequest,
): TGetNewbuildingsFromBuilderModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-search',
    pathApi: '/v1/get-newbuildings-from-builder/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetNewbuildingsFromBuilderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetNewbuildingsFromBuilderRequest;
}

export async function fetchGetNewbuildingsFromBuilder<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetNewbuildingsFromBuilderOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetNewbuildingsFromBuilderResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetNewbuildingsFromBuilderModel(parameters),
    config,
  )) as FetchResponse<TGetNewbuildingsFromBuilderResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingsFromBuilderResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetNewbuildingsFromBuilderResponse>;
}
